﻿import React from "react";
import { observer } from "mobx-react";
import type { PatientToUpload } from "../../../../PatientToUpload";
import type { IResourcesStore } from "../../../../../resources/ResourcesStore";
import { injectFromAppUpload } from "../../../../inject";
import { ProgressBarComponent } from "../../../../../shared-components/progress-bar/ProgressBarComponent";
import { humanizeFileSize } from "../../../../../util/functions/humanizeFileSize";
import { UploadStatus } from "../../../../FileUpload";

interface IUploadProgressComponentProps {
    resourcesStore?: IResourcesStore;
    patientToUpload: PatientToUpload;
}

@injectFromAppUpload<IUploadProgressComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
@observer
export class UploadProgressComponent extends React.Component<IUploadProgressComponentProps> {
    render() {
        const { resourcesStore, patientToUpload } = this.props;
        const { resources } = resourcesStore!;
        const { status, numberOfFilesDoneUploading, totalUploadedInPercentage, totalUploadedInBytes, filesToUpload, filesToUploadTotalSize } = patientToUpload;

        return (
            <div className={"upload-status-component"}>
                <ProgressBarComponent progress={totalUploadedInPercentage} status={status}>
                    {status === UploadStatus.NotStarted ? (
                        <>
                            {filesToUpload.length === 1 ? resources.OneFile : resources.XFiles.replace("{0}", filesToUpload.length.toString())}
                            <span>({humanizeFileSize(filesToUploadTotalSize)})</span>
                        </>
                    ) : (
                        <>
                            {filesToUpload.length === 1
                                ? resources.UploadedXFile.replace("{0}", numberOfFilesDoneUploading.toString() + " / " + filesToUpload.length.toString())
                                : resources.UploadedXFiles.replace("{0}", numberOfFilesDoneUploading.toString() + " / " + filesToUpload.length.toString())}

                            <span>
                                ({humanizeFileSize(totalUploadedInBytes)} / {humanizeFileSize(filesToUploadTotalSize)})
                            </span>
                        </>
                    )}
                </ProgressBarComponent>
            </div>
        );
    }
}
